import {GET_ROBOTS_CSV_SUCCESS} from "../../../reducers/robotsAndVehiclesReducer";

export const getRobotsCsvSuccess = (csv) =>{
    return {
        type: GET_ROBOTS_CSV_SUCCESS,
        payload: {csv}
    }
}